module.exports = __webpack_public_path__ + "static/media/okta-code.9abe1d3b.svg";